import { Select } from '@/components';
import { PageSize, TableTypes } from '@/constant';
import { useSearchFilterParams } from '@/hooks';
import { cn } from '@/utils';
import { isMobile } from '@/utils/mobile.util';
import { memo, useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { DefaultOptionType } from 'antd/es/select';

import { TFunction } from 'i18next';

const getOptions = (t?: TFunction<'common', undefined>) =>
	[
		PageSize.XXS,
		PageSize.XS,
		PageSize.S,
		PageSize.M,
		PageSize.L,
		PageSize.XL,
		PageSize.XXL,
	].map((_) => ({
		value: _,
		label: `${_}${t?.('items')}`,
	}));

export type TPageSize = {
	pageSizeHidden?: boolean;
	onPageSizeChange?: (
		value: DefaultOptionType['value'],
		option: DefaultOptionType | DefaultOptionType[]
	) => void;
	defaultPageSize?: PageSize;
	tableType?: TableTypes;
	containerClassName?: string;
};

const PageSizeFilter = ({
	pageSizeHidden,
	onPageSizeChange,
	defaultPageSize = PageSize.XS,
	tableType,
	containerClassName,
}: TPageSize) => {
	const { t } = useTranslation('common');

	if (pageSizeHidden) {
		return null;
	}

	const [_, setSearchParams] = useSearchFilterParams(tableType || '');

	const options = useMemo(() => getOptions(t), [t]);

	const _onChange = useCallback(
		(value: any, option: DefaultOptionType | DefaultOptionType[]) => {
			setSearchParams({ page: 1, pageSize: value as PageSize });

			onPageSizeChange?.(value, option);
		},
		[setSearchParams, onPageSizeChange]
	);

	return (
		<Select
			className="h-10 page-size-filter"
			value={defaultPageSize}
			options={options}
			onChange={_onChange}
			containerClassName={cn(
				'absolute top-[-2px] right-0 lg:static w-[84px] md:w-[88px] lg:w-[90px] xl:min-w-[90px] xl:w-max',
				containerClassName
			)}
			rootClassName={`${isMobile ? '!h-auto [&>.ant-select-selector]:!w-[85px] [&>.ant-select-selector]:!h-[28px] [&>div.ant-select-selector]:!rounded-[4.167vw] [&>.ant-select-selector]:!text-[12px]' : ''}`}
		/>
	);
};

export default memo(PageSizeFilter);
